import React, { useEffect, useState } from "react";
import "./Styles/App.css";
//Design themes here: https://fabricweb.z5.web.core.windows.net/pr-deploy-site/refs/heads/master/theming-designer/index.html
import { loadTheme, createTheme, getTheme } from "@fluentui/react";
import { initializeIcons } from "@uifabric/icons";
import { Portal } from "./Portal";
import { Unauthenticated } from "./Unauthenticated";
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
} from "@azure/msal-react";
import { MenuContext } from "./Contexts/MenuContext";
import { FrameContext } from "./Contexts/FrameContext";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";

export default function App(props) {
  useEffect(() => {
    setTheme();
    document.title = window.configs.HOME_TITLE;
  }, []);

  const [menuContext, setMenuContext] = useState({
    loadingMenu: true,
    menu: [],
    menuEdit: [],
    menuEditStateDisplay: false,
    menuEditStateId: "",
    menuEditStateSeverity: null,
    menuEditStateMessage: "",
    loadingMenuBar: true,
    menuBar: [],
    home: null,
    loadingAvatar: true,
    avatar: "",
    isMenuOpen: false,
    isEditing: false,
  });
  const [frameContext, setFrameContext] = useState({
    frameName: "",
    frameSrc: "",
    isFetchingFrameTokens: true,
  });

  useEffect(() => {
    setMenuContext((prevState) => ({
      ...prevState,
      menuEditStateDisplay: false,
    }));
  }, [menuContext.isEditing]);

  return (
    <div
      className="App"
      style={{
        background: getTheme().palette.neutralLighter,
      }}
    >
      <AuthenticatedTemplate>
        <DndProvider backend={HTML5Backend}>
          <MenuContext.Provider value={[menuContext, setMenuContext]}>
            <FrameContext.Provider value={[frameContext, setFrameContext]}>
              <Portal></Portal>
            </FrameContext.Provider>
          </MenuContext.Provider>
        </DndProvider>
      </AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <Unauthenticated />
      </UnauthenticatedTemplate>
    </div>
  );
}

export const setTheme = () => {
  initializeIcons();

  var darkPaletteData = require("../theme-dark.json");
  let myTheme = createTheme({
    palette: darkPaletteData,
    defaultFontStyle: { fontFamily: "Open Sans", fontWeight: "regular" },
  });

  loadTheme(myTheme);
  return myTheme;
};
